
/**
 * Formata um valor como um documento, CPF ou CNPJ
 * @param {String} valor Valor a ser formatado
 * @returns {String} Retorna o valor com a máscara de CPF ou de CNPJ
 */
function formatarCpfCnpj(valor) {
    if (valor.length > 11) {//CNPJ
        valor = valor.padStart(14, '0');
        return valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    } else {//CPF
        valor = valor.padStart(11, '0');
        return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
}

export default formatarCpfCnpj;